import { Card, CompartmentCard } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import { ReorderableItems } from "@/src/components/reorderable";
import {
  Reference,
  referenceCategories,
  ReferenceCategory,
} from "@/src/data/allTypes";
import { uid } from "@/src/utils/utils";
import { useState } from "react";
import { FrequentReferencesCreationList } from "./frequentReferencesCreationList";

export function FrequentReferencesList({
  title,
  currentReferences,
  onChange,
}: {
  title?: string;
  currentReferences: (Reference | null | undefined)[];
  onChange?: (newValue: (Reference | null | undefined)[]) => void;
}) {
  const [reload, setReload] = useState(0);
  let [references, setReferences] = useState(currentReferences || []);

  function localOnChange(newValue: (Reference | null | undefined)[]) {
    setReferences([...newValue]);
    onChange?.([...newValue]);
  }
  return (
    <CompartmentCard
      title={title || "Signes fréquents"}
      onClick={async () => {
        await openDrawer({
          id: "referencesChoiceDialog",
          title: "Choisir un signe",
          content: (
            <FrequentReferencesCreationList
              categories={
                Object.keys(referenceCategories).filter(
                  (item) => item != "cim10" && item != "cim11"
                ) as ReferenceCategory[]
              }
              value={references || []}
              onSelect={(selectedReferences) => {
                references = selectedReferences;
                localOnChange(references);
              }}
            ></FrequentReferencesCreationList>
          ),
          footer: <div></div>,
          onConfirm: () => {
            setReload(reload + 1);
            localOnChange(references);
          },
        });
      }}
    >
      <FetchableList
        queryFn={() => references || []}
        queryKey={[
          "FrequentReferencesList",
          JSON.stringify(references || []),
          reload,
        ]}
      >
        {(data) => (
          <div className="grid c1 gap10">
            <ReorderableItems
              key={uid()}
              listId="frequentReferences"
              listType={`frequentReferences`}
              items={references || []}
              isHorizontal={false}
              onReorder={async (items, oldIndex, newIndex, movedItem) => {
                localOnChange(items);
              }}
              onRemove={async (removedItem) => {
                let newReferences = references?.filter(
                  (reference) => reference?.id != removedItem.id
                );

                localOnChange(newReferences);
              }}
            >
              {references?.map((reference) => {
                if (!reference) return null;
                let referenceCategory =
                  referenceCategories[reference.category || "other"];
                return (
                  <Card
                    key={uid()}
                    color="blue"
                    title={reference.name}
                    subTitle={reference.snomedConcept?.name}
                    trailing={reference.usageCount}
                    onDelete={() => {
                      let newReferences = references?.filter(
                        (item) => item?.id != reference.id
                      );
                      localOnChange(newReferences);
                    }}
                  >
                    <div className="gray">{referenceCategory.name}</div>
                  </Card>
                );
              })}
            </ReorderableItems>
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}



